<template>
  <tr>
    <td>
      {{ dayMonth(report.created_at) }}
    </td>
    <td>
      {{ report.orders.length }}
    </td>
    <td>
      <small>
        {{ report.file_name }}
      </small>
    </td>
    <td>
      <small>
        {{ sizeReadable(report.size) }}
      </small>
    </td>
    <td>
      <div v-if="report.downloaded_at">
        {{ dayMonth(report.downloaded_at) }}
        {{ minuteHour(report.downloaded_at) }}
      </div>
      <div v-else>
        <small>
          <small class="text-muted">
            <i>Ännu inte nerladdad</i>
          </small>
        </small>
      </div>
    </td>
    <td>
      <a class="btn btn-success btn-sm" :href="download">
        <font-awesome-icon icon="download" />
        Ladda ner
      </a>
    </td>
  </tr>
</template>

<script>

  import DateMixin from "../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "ReportItem",
    mixins: [
      DateMixin
    ],
    props: {
      report: {
        required: true,
        format: Object
      }
    },
    computed: {
      download(){
        return `/report/${this.report.uuid}/download`
      }
    },
    methods: {
      sizeReadable(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

        if (!bytes){
          return '0 Byte'
        }

        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Reports/Partials/ReportItem.vue